<bit-callout type="info" title="{{ 'prerequisite' | i18n }}">
  {{ "blockClaimedDomainAccountCreationPrerequisite" | i18n }}
  <a
    bitLink
    href="https://bitwarden.com/help/domain-verification/"
    target="_blank"
    rel="noreferrer"
    >{{ "learnMore" | i18n }}</a
  >
</bit-callout>

<bit-form-control>
  <input type="checkbox" id="enabled" bitCheckbox [formControl]="enabled" />
  <bit-label>{{ "turnOn" | i18n }}</bit-label>
</bit-form-control>
